import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class TemporaryContractor {
  // @IsOptional()
  // @IsString()
  // @Expose()
  // id!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  shortName!: string;
  @IsOptional()
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  surname!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  nationalBusinessRegistryNumber!: string | null;
  @IsBoolean()
  @Expose()
  isIndividual!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  country!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  city!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  postalCode!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  streetAndNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  contractorMonit!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  importedContractorId!: string | null;
  @IsOptional()
  @IsNumber()
  @Expose()
  contractorProviderId!: number | null;
  @IsBoolean()
  @Expose()
  isHidden!: boolean;
  @IsBoolean()
  @Expose()
  chargeFromCurrent!: boolean;
  @IsBoolean()
  @Expose()
  attributesFromCurrent!: boolean;
  @IsBoolean()
  @Expose()
  summaryPrint!: boolean;
}

export class OrderGetTemporaryContractors {
  @Type(() => TemporaryContractor)
  @ValidateNested()
  @Expose()
  buyer!: TemporaryContractor;
  @Type(() => TemporaryContractor)
  @ValidateNested()
  @Expose()
  payer!: TemporaryContractor;
  @Type(() => TemporaryContractor)
  @ValidateNested()
  @Expose()
  receiver!: TemporaryContractor;
  @Type(() => TemporaryContractor)
  @ValidateNested()
  @Expose()
  seller!: TemporaryContractor;
  @Type(() => TemporaryContractor)
  @ValidateNested()
  @Expose()
  organizationalUnit!: TemporaryContractor;
}
